export const ARTICLES = [
  {
    slug: "cara-memilih-jasa-listrik-batam-terpercaya",
    title: "Cara Memilih Jasa Listrik di Batam yang Terpercaya",
    excerpt:
      "Panduan praktis memilih teknisi listrik di Batam agar pekerjaan aman, sesuai PUIL, dan bergaransi.",
    category: "Tips",
    readingTime: "6 menit",
    date: "2024-12-01",
    cover:
      "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBlbGVjdHJpY2lhbiUyMHdvcmtpbmd8ZW58MHx8fHwxNzc2NzU1NDI5fDA&ixlib=rb-4.1.0&q=85",
    content: [
      "Memilih jasa listrik di Batam yang tepat sangat penting untuk keselamatan keluarga dan properti Anda. Instalasi listrik yang asal-asalan bisa memicu korsleting, kebakaran, bahkan kematian. Berikut 5 hal yang wajib Anda cek sebelum memutuskan.",
      "1. Pastikan teknisi memiliki sertifikat kompetensi ketenagalistrikan. Sertifikat ini menjadi bukti bahwa teknisi sudah diuji dan memahami standar PUIL 2011.",
      "2. Cek legalitas perusahaan. Perusahaan jasa listrik yang baik memiliki NIB, NPWP, dan alamat kantor jelas seperti Tiban Koperasi E 12 B Batam.",
      "3. Minta rincian kabel, MCB, dan komponen yang digunakan. Hindari kabel di bawah standar SNI karena mudah panas dan memicu kebakaran.",
      "4. Garansi pengerjaan minimal 3 bulan. Garansi menunjukkan keyakinan teknisi pada kualitas pekerjaan mereka.",
      "5. Testimoni pelanggan lokal. Cek ulasan Google Maps dan Instagram untuk area Batu Aji, Sekupang, Nagoya, dan sekitarnya.",
    ],
  },
  {
    slug: "tanda-instalasi-listrik-rumah-bermasalah",
    title: "7 Tanda Instalasi Listrik Rumah Anda Bermasalah",
    excerpt:
      "Jangan tunggu korsleting. Kenali 7 tanda bahwa instalasi listrik rumah Anda perlu diperbaiki segera.",
    category: "Panduan",
    readingTime: "5 menit",
    date: "2024-11-18",
    cover:
      "https://images.unsplash.com/photo-1764973820916-4ca84d0a1d40?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxlbGVjdHJpY2FsJTIwcGFuZWwlMjBidWlsZGluZ3xlbnwwfHx8fDE3NzY3NTU0Mjh8MA&ixlib=rb-4.1.0&q=85",
    content: [
      "Instalasi listrik yang bermasalah sering kali memberi sinyal sebelum terjadi bencana. Jika Anda menemukan satu saja dari tanda berikut, segera hubungi teknisi listrik profesional.",
      "1. MCB sering turun tanpa sebab jelas. Ini tanda ada beban berlebih atau korsleting kecil.",
      "2. Stop kontak berubah warna kecokelatan atau berbau gosong. Hentikan penggunaan, bisa memicu api.",
      "3. Lampu berkedip saat beban lain dinyalakan. Instalasi tidak seimbang.",
      "4. Ada dengungan di panel utama. Terminal kendor bisa memicu panas berlebih.",
      "5. Tagihan listrik naik drastis tanpa perubahan pemakaian. Curigai kebocoran arus.",
      "6. Terasa setrum ringan saat menyentuh casing alat elektronik. Grounding bermasalah.",
      "7. Kabel terlihat retak atau meleleh. Harus segera diganti.",
    ],
  },
  {
    slug: "standar-grounding-yang-aman",
    title: "Standar Grounding yang Aman untuk Rumah di Batam",
    excerpt:
      "Grounding bukan sekadar menancapkan kabel ke tanah. Simak standar yang benar sesuai PUIL.",
    category: "Teknis",
    readingTime: "7 menit",
    date: "2024-11-02",
    cover:
      "https://images.unsplash.com/photo-1758468274726-1197049bbfa9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGJsdWUlMjBvcmFuZ2UlMjB0ZWNobm9sb2d5JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzY3NTU0Mzl8MA&ixlib=rb-4.1.0&q=85",
    content: [
      "Grounding atau pembumian adalah sistem pengaman yang mengalihkan arus bocor ke tanah. Standar PUIL 2011 mensyaratkan nilai resistansi grounding maksimal 5 Ohm.",
      "Bahan ideal adalah tembaga murni (bare copper) dengan diameter 8 mm atau plat tembaga untuk tanah berpasir seperti beberapa wilayah Sekupang dan Batu Aji.",
      "Kedalaman minimum 2 meter, dan jika tidak tercapai nilai resistansi yang diminta, bisa menggunakan sistem parallel grounding atau penambahan garam tambang.",
      "Gunakan alat ukur earth tester untuk verifikasi. Teknisi ListrikBatam.com selalu menyertakan hasil pengukuran dalam laporan instalasi.",
    ],
  },
  {
    slug: "perbedaan-mcb-mccb-elcb",
    title: "Perbedaan MCB, MCCB, dan ELCB: Pilih yang Mana?",
    excerpt:
      "Jangan salah pilih pengaman listrik. Pahami fungsi MCB, MCCB, dan ELCB untuk rumah dan usaha Anda.",
    category: "Teknis",
    readingTime: "5 menit",
    date: "2024-10-20",
    cover:
      "https://images.unsplash.com/photo-1766739977020-0f85da85e9c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxiYXRhbSUyMGNpdHklMjBpbmRvbmVzaWElMjBza3lsaW5lfGVufDB8fHx8MTc3Njc1NTQyOHww&ixlib=rb-4.1.0&q=85",
    content: [
      "MCB (Miniature Circuit Breaker) berfungsi melindungi dari beban berlebih dan hubungan pendek, kapasitas umumnya 6–63 A untuk rumah tangga.",
      "MCCB (Moulded Case Circuit Breaker) digunakan untuk kapasitas lebih besar (100–1600 A) di panel industri dan gedung komersial.",
      "ELCB / RCCB (Earth Leakage / Residual Current Circuit Breaker) mendeteksi kebocoran arus ke tubuh manusia—wajib untuk kamar mandi dan area basah.",
      "Rekomendasi kami: rumah tinggal gunakan kombinasi MCB + ELCB, sementara bisnis atau pabrik perlu MCCB + ELCB + surge arrester.",
    ],
  },
  {
    slug: "hemat-listrik-tanpa-mengurangi-kenyamanan",
    title: "10 Cara Hemat Listrik Tanpa Mengurangi Kenyamanan",
    excerpt:
      "Trik mudah menghemat tagihan listrik bulanan hingga 30% tanpa perlu gelap-gelapan di rumah.",
    category: "Tips",
    readingTime: "4 menit",
    date: "2024-10-05",
    cover:
      "https://images.unsplash.com/photo-1758468274726-1197049bbfa9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxhYnN0cmFjdCUyMGJsdWUlMjBvcmFuZ2UlMjB0ZWNobm9sb2d5JTIwYmFja2dyb3VuZHxlbnwwfHx8fDE3NzY3NTU0Mzl8MA&ixlib=rb-4.1.0&q=85",
    content: [
      "Ganti semua lampu ke LED hemat energi—konsumsi 10x lebih rendah dari lampu pijar.",
      "Gunakan AC inverter dan atur suhu 24–26°C, kombinasikan dengan kipas plafon.",
      "Cabut charger dan alat elektronik yang tidak dipakai (standby power).",
      "Pasang timer untuk pompa air agar tidak menyala terus.",
      "Periksa kebocoran arus melalui megger setiap 6 bulan—sering jadi penyebab tagihan tinggi.",
      "Gunakan capacitor bank untuk rumah dengan beban besar, bisa menurunkan biaya hingga 15%.",
      "Bersihkan kondensor AC rutin, kotor bisa menambah 20% konsumsi listrik.",
      "Pertimbangkan solar panel untuk rumah di Nongsa, Batam Center, dan Tiban dengan sinar matahari melimpah.",
      "Gunakan kulkas inverter kelas energi A++.",
      "Matikan lampu teras siang hari dengan sensor cahaya otomatis.",
    ],
  },
  {
    slug: "panduan-panel-surya-batam",
    title: "Panduan Lengkap Panel Surya untuk Rumah di Batam",
    excerpt:
      "Batam punya intensitas matahari tinggi—panel surya bisa memotong tagihan listrik Anda separuh.",
    category: "Energi",
    readingTime: "8 menit",
    date: "2024-09-22",
    cover:
      "https://images.unsplash.com/photo-1621905251918-48416bd8575a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBlbGVjdHJpY2lhbiUyMHdvcmtpbmd8ZW58MHx8fHwxNzc2NzU1NDI5fDA&ixlib=rb-4.1.0&q=85",
    content: [
      "Batam menerima rata-rata 5.2 kWh/m²/hari matahari—salah satu yang tertinggi di Indonesia.",
      "Sistem 3 kWp untuk rumah tangga bisa menutup 60–80% konsumsi bulanan keluarga 4 orang.",
      "Opsi: on-grid (terhubung PLN), off-grid (dengan baterai), atau hybrid. Di Batam kami merekomendasikan hybrid karena sering mati listrik di beberapa area.",
      "Komponen utama: panel monocrystalline, inverter hybrid, baterai lithium, dan MCB DC.",
      "Estimasi payback period 6–8 tahun dengan umur panel 25 tahun.",
    ],
  },
];
